import ToolTip from "app/routes/Scheduling/ToolTip";
import React from "react";
import styles from "./styles.module.scss";

interface PropsDef {
  buttonText: string;
  tooltipText: string;
  tooltipTitle?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isActive: boolean;
  orientation: 'left' | 'right' | 'center';
  'data-testid'?: string;
}

const ButtonWithTooltip = ({ buttonText, tooltipText, tooltipTitle, onClick, isActive, orientation, 'data-testid': dataTestId }: PropsDef) => {
  return (
    <button
      className={`${styles.button} ${isActive ? styles.activeButton : styles.inactiveButton}`}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <span className={`${styles.text} ${isActive ? styles.activeText : styles.inactiveText}`}>
        {buttonText}
      </span>
      <span className={styles.tooltipContainer}>
        <ToolTip text={tooltipText} title={tooltipTitle} selected={true} iconColor={isActive ? 'white' : null} orientation={orientation} />
      </span>
    </button>
  );
};

export default ButtonWithTooltip;
